import { useCartData, useAddToCart, useUpdateCartItem, useClearCart } from './useQueries';

export function useCart() {
  const { data: cart = [], isLoading: loading } = useCartData();
  const addToCartMutation = useAddToCart();
  const updateCartMutation = useUpdateCartItem();
  const clearCartMutation = useClearCart();

  const addToCart = async (productId: string) => {
    try {
      await addToCartMutation.mutateAsync(productId);
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  };

  const updateQuantity = async (cartItemId: string, quantity: number) => {
    try {
      await updateCartMutation.mutateAsync({ cartItemId, quantity });
    } catch (error) {
      console.error('Error updating cart:', error);
      throw error;
    }
  };

  const clearCart = async () => {
    try {
      await clearCartMutation.mutateAsync();
    } catch (error) {
      console.error('Error clearing cart:', error);
      throw error;
    }
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + (item.product.price * item.quantity), 0);
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return {
    cart,
    loading,
    addToCart,
    updateQuantity,
    clearCart,
    getTotalPrice,
    getTotalItems
  };
}
